import classNames from 'classnames';
import { FC } from 'react';

import type { ArticleTag } from '@/entities/article';
import { Icon } from '@/shared/ui';

import styles from './tagList.module.scss';

interface TagListProps {
  tags: ArticleTag[];
  className?: string;
  selectedTags?: string[];
  onChooseTag?: (tags: string[]) => void;
}

const TagList: FC<TagListProps> = (props) => {
  const { tags, className, selectedTags = [], onChooseTag } = props;

  function toggleTag(id: string) {
    const nextTags = selectedTags.includes(id)
      ? selectedTags.filter((t) => t !== id)
      : [...selectedTags, id];

    onChooseTag?.(nextTags);
  }

  function renderTags(tag: ArticleTag, index: number) {
    const tagId = String(tag.id);
    const isActive = selectedTags.includes(tagId);
    return (
      <li key={index} className={styles.list__item}>
        <button className={styles.list__btn} onClick={() => toggleTag(tagId)}>
          <span
            className={classNames(
              styles.list__text,
              isActive && styles['list__text--active'],
            )}
          >
            #{tag.name}
          </span>
        </button>
        {isActive && (
          <button
            className={styles.list__reset}
            onClick={() => toggleTag(tagId)}
          >
            <Icon name="crossSmall" />
          </button>
        )}
      </li>
    );
  }

  return (
    <ul className={classNames(styles.list, className)}>
      {tags?.map(renderTags) ?? []}
    </ul>
  );
};

export default TagList;
